import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { activateUser } from '../../../../services/services';
import Card from "../../../MyUI/Card/Card"; // reuse your Card if you want consistent UI

export default function ActivateUser() {
  const { token } = useParams();

  const [message, setMessage] = useState(""); // "true" | "false" | ""
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const activate = async () => {
      setLoading(true);
      try {
        const res = await activateUser(token);
        setMessage("true");
      } catch (err) {
        console.error(err);
        setError(err);
        setMessage("false");
      } finally {
        setLoading(false);
      }
    };

    activate();
  }, [token]);


  return (
    <div className="d-flex justify-center mb-6 bg-surface-variant">
      <Card title="" showChevron={false} style={{ width: "500px" }}>
        {loading && <div style={{textAlign: "center"}}>Activating user...</div>}

        {!loading && message === "true" && (
          <div style={{textAlign: "center"}}>
            <h2 style={{ "color": "#43A047" }}>User Activated!</h2>

            <Link to="/ConnectionPopUp" className="nav-link">
              <button className="label-btn" style={{ "--label-btn-color": "#43A047" }}>
                Connect here
              </button>
            </Link>
          </div>
        )}

        {!loading && message === "false" && (
          <div style={{textAlign: "center"}} className="error">
            Link expired!
          </div>
        )}
      </Card>
    </div>
  );
}
